<template>
  <div class="container">
    <div class="header">
      <HeadingSmall> {{ overviewStep.headerText }} </HeadingSmall>

      <Button
        data-test-id="ProductTourModal__hideButton"
        hasNoBackground
        :text="$options.hideLabel"
        @click="handleHide"
      />
    </div>

    <img
      :alt="overviewStep.imgAltText"
      class="diagram"
      :src="overviewStep.image"
    >

    <MarkdownBlock
      class="text"
      :mdTemplate="overviewStep.bodyText"
    />

    <footer
      class="footer"
    >
      <ProductTourPagination />
    </footer>
  </div>
</template>

<script>
import {
  Button, HeadingSmall, MarkdownBlock,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import { productTourLabels } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

import ProductTourMixin from './ProductTourMixin';
import ProductTourPagination from './ProductTourPagination.vue';
import ProductTourSteps, { stepIndexes } from './ProductTourSteps';

const onboardingModule = 'OnboardingModule';

export default {
  name: 'ProductTourModal',

  EventHelper,
  ProductTourSteps,
  hideLabel: productTourLabels.hide,

  components: {
    Button,
    HeadingSmall,
    MarkdownBlock,
    ProductTourPagination,
  },

  mixins: [ProductTourMixin],

  computed: {
    ...mapState(onboardingModule, [
      'productTourStepIndex',
    ]),

    overviewStep() {
      return this.$options.ProductTourSteps[stepIndexes.modal];
    },
  },

  methods: {
    handleHide() {
      this.$options.EventHelper.triggerButtonClicked({
        location: productTourLabels.popoverLocation,
        step: this.productTourStepIndex,
        text: productTourLabels.hide,
      });

      this.closeModal();
    },
  },
};
</script>

<style scoped>
  .container {
    padding: var(--jc-spacer-medium);
    width: 400px;
  }

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--jc-spacer-large);
  }

  .diagram {
    margin-bottom: var(--jc-spacer-large);
    width: 100%;
  }

  .text {
    font-size: 14px;
  }

  .footer {
    margin-top: var(--jc-spacer-large);
  }
</style>
